export const empty = ($el: Element) => {
	if ($el) {
		let currentChild;

		while ((currentChild = $el.firstChild)) {
			currentChild.remove();
		}
	}
};
